import axios, { AxiosInstance } from 'axios';
import { AbstractRequest, Config } from './abstract-request';


// 过滤掉浏览器不允许设置的header
const filterUnsafeHeaders = (config: Config = {}): Config => {
  if (!config.headers) return config;

  // 需要忽略的header列表
  const headersToFilter = ['referer', 'user-agent'];
  const safeHeaders = { ...config.headers };

  // 忽略大小写
  Object.keys(safeHeaders).forEach((header) => {
    if (headersToFilter.some(h => h.toLowerCase() === header.toLowerCase())) {
      delete safeHeaders[header];
    }
  });

  return {
    ...config,
    headers: safeHeaders,
  };
};

export interface WebRequestOptions {
  afterAxiosCreate?: (axiosIns: AxiosInstance) => void | Promise<void>;
}

export default class WebRequest extends AbstractRequest {
  private axiosInsPromise: Promise<AxiosInstance>;
  constructor(options: WebRequestOptions = {}) {
    super();
    this.axiosInsPromise = new Promise<AxiosInstance>((resolve) => {
      (async () => {
        const axiosIns = axios.create({
          timeout: 10000, // 请求超时时间
        });
        try {
          await options.afterAxiosCreate?.(axiosIns);
        } catch (err) {
          console.error('afterAxiosCreate error', err);
        } finally {
          resolve(axiosIns);
        }
      })();
    });
  }

  async request(url: string, data: any, method: string) {
    const axiosIns = await this.axiosInsPromise;
    return axiosIns({
      url,
      data,
      method,
    });
  }

  async post<T>(url: string, data: any, config: Config) {
    const safeConfig = filterUnsafeHeaders(config);
    const axiosIns = await this.axiosInsPromise;
    return axiosIns<T>({
      method: 'post',
      url,
      data,
      withCredentials: true,
      ...safeConfig,
    });
  }

  async get<T>(url: string, params: any, config: Config) {
    const safeConfig = filterUnsafeHeaders(config);
    const axiosIns = await this.axiosInsPromise;
    return axiosIns<T>({
      method: 'get',
      url,
      params,
      ...safeConfig,
    });
  }

  cancelAllRequest() {
  }

  cancelAllRequestFromUrl(_url: string) {
  }
}
